export default function roundTwoDecimal(value = 0) {
  const result = Math.round(value * 100) / 100;
  return result;
}
